// src/pages/MyGroups/MyGroups.tsx
import React, { useState } from "react";
import { useGroups } from "@/hooks/useGroups";
import GroupRow from "./GroupRow";
import PlannerModal from "./PlannerModal";
import "./MyGroups.scss";
import { Spinner, Button } from 'react-bootstrap';

const MyGroups: React.FC = () => {
  const [query, setQuery] = useState("");
  const [selectedPlans, setSelectedPlans] = useState<{ title: string; id: string }[] | null>(null);
  const { groups, loading, error, searchGroups, nextLink, loadNext } = useGroups();

  const handleSearch = () => {
    searchGroups(query);
  };

  return (
    <div className="mygroups-page">
      <h4>My Groups</h4>
      <p className="text-muted">
        This page can be used to search for your Microsoft 365 groups. Owners can manage group
        membership, view files, and access related resources.
      </p>

      <div className="mygroups-searchbar">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          placeholder="Search by group name..."
        />
        <Button variant="primary" onClick={handleSearch}>
          Search
        </Button>
      </div>

      {loading &&
        <div className="text-center py-5">
          <Spinner
            animation="border"
            role="status"
            variant="primary"
            style={{ width: "4rem", height: "4rem", borderWidth: "0.4rem" }}
          />
        </div>
      }
      {error && <div className="text-red">{error}</div>}

      {!loading && groups.length > 0 && (
        <div className="mygroups-table">
          <div className="mygroups-header row">
            <div className="col-sm-8">Title</div>
            <div className="col-sm-4 text-right">Quick actions</div>
          </div>

          {groups.map((g) => (
            <GroupRow key={g.id} group={g} onPlannerClick={setSelectedPlans} />
          ))}

          {nextLink && (
            <div className="text-center mygroups-paging">
              <Button variant="primary" onClick={loadNext}>
                Load more
              </Button>
            </div>
          )}
        </div>
      )}

      {!loading && !error && groups.length === 0 && (
        <div className="no-results text-blue">No results found.</div>
      )}

      {/* Popup for multiple Planner plans */}
      {selectedPlans && (
        <PlannerModal
          plans={selectedPlans}
          onClose={() => setSelectedPlans(null)}
        />
      )}
    </div>
  );
};

export default MyGroups;